import { useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import mapboxgl from 'mapbox-gl'

const PopupOTB = ({ map, activeFeature }) => {

  // a ref to hold the popup instance
  const popupRef = useRef()
  // a ref for an element to hold the popup's content
  const contentRef = useRef(document.createElement("div"))

  // instantiate the popup on mount, remove it on unmount
  useEffect(() => {
    if (!map) return

    // create a new popup instance, but do not set its location or content yet
    popupRef.current = new mapboxgl.Popup({
      closeOnClick: false,
      offset: 20
    })

    return () => {
      popupRef.current.remove()
    }
  }, [])


  // when activeFeature changes, set the popup's location and content, and add it to the map
  useEffect(() => {
    if (!activeFeature) return

    popupRef.current
      .setLngLat(activeFeature.geometry.coordinates) // set its position using activeFeature's geometry
      .setHTML(contentRef.current.outerHTML) // use contentRef's `outerHTML` to set the content of the popup
      .addTo(map) // add the popup to the map
  }, [activeFeature])

  // use a react portal to render the content to show in the popup, assigning it to contentRef
  return (
    <>{
      createPortal(
        <div className="portal-content">
          <table>
            <tbody>
              
              <tr>
                <td><strong>Tipo</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Tipo}</td>
              </tr>
              { activeFeature?.properties.fecha?
              <tr>
                <td><strong>Fecha</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.fecha}</td>
              </tr>
              :null}
              {activeFeature?.properties.usuario?
              <tr>
                <td><strong>Usuario</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.usuario}</td>
              </tr>
              :null}
              {activeFeature?.properties.Distrito ?
              <tr>
                <td><strong>Distrito</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Distrito}</td>
              </tr>
              :null}
              {activeFeature?.properties.Cantidad ?
              <tr>
                <td><strong>Cantidad</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Cantidad}</td>
              </tr>
              :null}
              {activeFeature?.properties.Observ?
              <tr>
                <td><strong>Observación</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Observ}</td>
              </tr>
              :null}
              {activeFeature?.properties.Direcc?
              <tr>
                <td><strong>Dirección</strong></td>
                <td style={{marginLeft:".5rem"}}>{activeFeature?.properties.Direcc}</td>
              </tr>
              :null}
                     
             
              {/* <tr>
                <td><strong>Place</strong></td>
                <td></td>
              </tr> */}
            </tbody>
          </table>
        </div>,
        contentRef.current
      )
    }</>
  )
}

export default PopupOTB